// src/redux/thunks/authThunks.ts

import { createAsyncThunk } from "@reduxjs/toolkit";
import { fakeLogin } from "../apis/authAPIs";
import { loginAPI, forgotPasswordAPI, resetPasswordAPI, verifyOTPAPI } from "../apis/auth";

// Legacy login thunk (keeping for backward compatibility)
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (data: { email_phone: string; password: string }, thunkAPI) => {
    try {
      const response = await fakeLogin(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// New login thunk
export const loginUserNew = createAsyncThunk(
  "auth/loginUserNew",
  async (credentials: { email: string; password: string }, thunkAPI) => {
    try {
      const response = await loginAPI(credentials);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || 'Login failed');
    }
  }
);

// Forgot password thunk
export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (data: { email: string }, thunkAPI) => {
    try {
      const response = await forgotPasswordAPI(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || 'Forgot password request failed');
    }
  }
);

// Reset password thunk
export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (data: { token: string; newPassword: string }, thunkAPI) => {
    try {
      const response = await resetPasswordAPI(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || 'Password reset failed');
    }
  }
);

// Verify OTP thunk
export const verifyOTP = createAsyncThunk(
  "auth/verifyOTP",
  async (data: { email: string; otp: string }, thunkAPI) => {
    try {
      const response = await verifyOTPAPI(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || 'OTP verification failed');
    }
  }
);
